import React, { FunctionComponent, useState, useRef, useEffect } from "react";
import styles from "../ListViewModal/ListViewModal.module.css";
import Modal from "react-modal";
import { connect, useDispatch } from "react-redux";

import Loading from "../../Loading/Loading";

import { createApiTokenMongo,updateApiTokenMongo } from "../../../Services/organizations";
import { showSnackbarAction } from "../../../Redux/actions";
import TextInput from "../../TextInput/TextInput";
import InputWithAutoComplete from "../../DropDown/InputWithAutoComplete";

type props = {
  open: boolean;
  close: () => void;
  organizationId: any;
  organizationUsers: any;
  constants:any;
  edit?: boolean;
  editData?: any;
  editClose?: () => void;
  user?: any;
  authToken?: any;
};

const ApiModal: FunctionComponent<props> = ({
  organizationId,
  open,
  close,
  constants,
  edit,
  editData,
  editClose,
  user,
  authToken
}) => {

  const sourceRef: any = useRef();
  const countryRef: any = useRef();
  const [load, setLoad] = useState(false);
  const [leadSources, setLeadSources] = useState();
  const [source, setSource]:any = useState( { label: 'MagicBricks', value: 'MagicBricks'});
  const [countryCode, setCountryCode] = useState();

  const constant = async () => {
    const leadSources = constants.leadSources;
    setLeadSources(leadSources);
  };

  useEffect(() => {
    if (constants) {
      constant();
    }
  }, []);

  const dispatcher = useDispatch();
  const onSave = () => {
    if (source === "") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
    } else {
      setLoad(true);

      createApiTokenMongo(
        organizationId,
        source,
        countryRef.current.value === ""
          ? ""
          : countryRef.current.value.startsWith("+")
          ? countryRef.current.value
          : "+" + countryRef.current.value,
        dispatcher,
        (val) => setLoad(val),
        close,
        user.uid,
        authToken
      );
    }
  };

  const onEdit = () => {
    if (source === "") {
      dispatcher(showSnackbarAction("Please Enter Source!!", "error"));
    } else {
      if (editClose) {
        setLoad(true);
        updateApiTokenMongo(
          source,
          countryRef.current.value === ""
            ? ""
            : countryRef.current.value.startsWith("+")
            ? countryRef.current.value
            : "+" + countryRef.current.value,
          editData._id,
          dispatcher,
          (data) => setLoad(data),
          close,
          editClose,
          authToken,
          user.uid,
          organizationId
        );
      }
    }
  };

  useEffect(() => {
    if (edit) {
      setSource(editData.source);
      setCountryCode(editData.country_code);
    }
  }, []);
  return (
    <Modal
      isOpen={open}
      className={styles.parent}
      overlayClassName={styles.overlay}
      onRequestClose={close}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
    >
      {load && <Loading />}
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Create API</p>
      </div>
      <div className={styles.profileContainer}>
        <p className={styles.profile}>Enter Source</p>
        {/* <TextInput
          title={"Enter Source"}
          ref={sourceRef}
          disabled={false}
          value={source}
          style={{ marginTop: "-0.5px" }}
        /> */}
        <InputWithAutoComplete value={source} options={leadSources} setValue={(val:any)=>{setSource(val)}} />
      </div>

      <div className={styles.profileContainer}>
        <p className={styles.profile} style={{ marginTop: "20px" }}>
          Enter Country Code
        </p>
        <TextInput
          title={"Enter Country Code"}
          ref={countryRef}
          disabled={false}
          value={countryCode}
          style={{ marginTop: "-0.5px" }}
        />
        
      </div>

      <div className={styles.buttonView}>
        <button
          className={styles.cancelButton}
          onClick={() => {
            close();
            editClose && editClose();
          }}
        >
          Cancel
        </button>
        {edit === true ? (
          <button className={styles.saveButton} onClick={() => onEdit()}>
            Edit
          </button>
        ) : (
          <button className={styles.saveButton} onClick={() => onSave()}>
            Save
          </button>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    user: state.user.data,
    authToken: state.user.authToken,
    constants:state.constants.data,
  };
};

export default connect(mapStateToProps)(ApiModal);
